export default "const a = \"a\", b = \"b\", c = \"c\";\n"